import WelcomeBackCard from "components/card/welcome-back/WelcomeBackCard";
import ApplicationContainer from "components/application-container/ApplicationContainer";

const WelcomeBackPage = () => {
    return (
        <>
            <title>Welcome Back | AAA Life</title>
            <ApplicationContainer data-testid="welcome-back-page">
                <WelcomeBackCard />
            </ApplicationContainer>
        </>
    );
};

export { WelcomeBackPage };
export default WelcomeBackPage;
